import { z } from 'zod';

export const SessionInitDTO = z.object({
    sessionInit: z.boolean(),
    data: z.any(), // Came from server actions which are already validated
});

export type SessionInitDTO = z.infer<typeof SessionInitDTO>;
